import React from 'react'
import { RouteProps, Route, Redirect, useLocation } from 'react-router-dom'
import routes from 'routes'
import { isPublicPanel, Validation } from '../utils'
import queryString from 'query-string'

const PublicRoute: React.FC<RouteProps> = (props) => {
  const { children, ...rest } = props

  const { isValidUserToken } = new Validation()

  function isAuthorizedUser(): boolean {
    // TODO: json error
    // SyntaxError: JSON.parse: unexpected character at line 1 column 1 of the JSON data
    const { token } = JSON.parse(localStorage.getItem('user') || '{}')

    return token === undefined ? false : isValidUserToken(token)
  }

  const location = useLocation()

  const params = queryString.parse(location.search)
  const code = params['code'] ? `?code=${params['code']}` : ''
  return (
    <Route
      {...rest}
      render={(): any =>
        rest.path === routes.startQrcode ? <Redirect
            to={`${routes.addUserSubscription}${code}`}
          /> :
        isAuthorizedUser() ? (
          <Redirect
            to={{
              pathname: isPublicPanel()
                ? routes.defaultPathForEndUser
                : routes.defaultPath,
            }}
          />
        ) : (
          children
        )
      }
    />
  )
}

export default PublicRoute;
